import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=a56b0f54&scoped=true"
import script from "./Poll.vue?vue&type=script&lang=js"
export * from "./Poll.vue?vue&type=script&lang=js"
import style0 from "./Poll.vue?vue&type=style&index=0&id=a56b0f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56b0f54",
  null
  
)

export default component.exports